export const GENDER = [
    {label: "Nam",value:1},
    {label: "Nữ",value:0},
]